"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGImageUploadField = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const TGMediaField_1 = __importDefault(require("./TGMediaField"));
const common_1 = require("../../utils/common");
const styles_1 = require("@material-ui/core/styles");
const react_webcam_1 = __importDefault(require("react-webcam"));
const core_1 = require("@material-ui/core");
const defaultProps = {
    captureLabel: 'Image Capture Type',
    fileUploadLabel: 'File upload',
    deviceUploadLabel: 'Use Device Camera',
    dragLabel: 'Drag and Drop image files here',
    allowedTypes: ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'pdf'],
    limitInMb: 50,
    captureFileLabel: 'CAPTURE IMAGE',
    mediaType: 'image',
};
const TGImageUploadField = (props) => {
    const styles = useStyles();
    const cameraRef = (0, react_1.useRef)(null);
    const onCapture = (0, react_1.useCallback)((addFileToList) => {
        const imageSrc = lodash_1.default.result(cameraRef.current, 'getScreenshot');
        if (imageSrc) {
            addFileToList((0, common_1.dataURItoBlob)(imageSrc));
        }
    }, [cameraRef]);
    return (react_1.default.createElement(TGMediaField_1.default, Object.assign({}, defaultProps, props, { type: 'imageupload', renderMedia: (addFileToList) => {
            return (react_1.default.createElement("div", { className: styles.cameraSection },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_webcam_1.default, { screenshotFormat: "image/jpeg", ref: cameraRef, videoConstraints: { facingMode: 'environment' }, width: '100%' })),
                react_1.default.createElement(core_1.Button, { className: styles.captureButton, variant: "contained", onClick: () => onCapture(addFileToList) }, defaultProps.captureFileLabel)));
        } })));
};
exports.TGImageUploadField = TGImageUploadField;
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    cameraSection: {
        margin: '10px 8px',
    },
    captureButton: {
        margin: '10px 0px',
    },
}));
exports.default = exports.TGImageUploadField;
//# sourceMappingURL=TGImageUploadField.js.map